<template>
    <div class="root_page_center wrapper_linkaccount">
        <div class="row titleMenu">
            Đăng ký ngân hàng
        </div>
        <div class="wp_accountbank">
            <h3 class="title_dxcao">Đề xuất cao</h3>
            <div class="row">
                <div class="wp-accountbank--border" v-if="listBank && listBank.length">
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemBank" v-for="(item, index) in listBank" :key="index">
                        <div class="itemBank">
                            <img :src="linkWebAdmin + item.image" alt="" @click="showMd()">
                            <img src="../assets/images/st.png" alt="" class="iconstar">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-4 wp_itemBank" v-for="(item, index) in listBank1" :key="index">
                    <div class="itemBank">
                        <img :src="linkWebAdmin + item.image" alt="" @click="showMds()">
                    </div>
                </div>
            </div>
            <div class="modalRedirect" v-if="showmodal">
                <div class="content_modalredirect">
                    <p @click="showmodal = false" class="closeMdredirect">
                        <img src="../assets/images/close.png" @click="showmodal = false" alt="">
                    </p>
                    <h3>Vui lòng làm theo hướng dẫn của cán bộ đang hỗ trợ để đăng ký tài khoản.</h3>
                    <router-link to="/loading">
                        <button type="button"> Xác nhận đăng ký</button>
                    </router-link>
                </div>
            </div>
            <div class="modalRedirect modal_register_success" v-if="showmodals">
                <div class="content_modalredirect content_modalredirectHds">
                    <p @click="showmodals = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodals = false" alt=""></p>
                    <div class="wrp_modal_type">
                        <h6>Hiện tại ngân hàng đang bảo trì hệ thống sinh trắc học. Vui lòng chọn ngân hàng khác để kê khai</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegisterOnline_tool',
    data() {
        return {
            token: window.localStorage.getItem('token'),
            listBank: [],
            listBank1: [],
            showmodal: false,
            showmodals: false,
            itemBank: [],
        }
    },
    components: {

    },
    mounted() {

    },
    created() {
        this.getListBank()
        this.getListBank1()
    },
    computed: {

    },
    beforeUnmount() {

    },
    methods: {
        getListBank() {
            this.axios.get(this.api_logoBanks + '?status=1').then((response) => {
                this.listBank = response.data.data
            }).catch(e => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getListBank1() {
            this.axios.get(this.api_logoBanks + '?status=0').then((response) => {
                this.listBank1 = response.data.data
            })
        },
        showMd() {
            this.showmodal = true
            // this.itemBank = this.listBank[index]
            // window.localStorage.setItem('nameBank', this.itemBank.name)
            // window.localStorage.setItem('title', this.itemBank.blue_text)
            // window.localStorage.setItem('icon', this.itemBank.logo)
            // window.localStorage.setItem('idbank', this.itemBank.id)
        },
        showMds() {
            this.showmodals = true
        },
    }
}
</script>